<template>
  <div>
    <b-form-input v-model="rawInput" :value="value" @input="$emit('input', returnValue())" :state="valid" :placeholder="placeholder"/>
  </div>
</template>

<script>
import {Numbers} from '@/util/numbers'
import {NumberFormats} from '@/util/constants'

var bases = {
  'binary': 2,
  'decimal': 10,
  'hexadecimal': 16
}

export default {
  name: 'UcrDrkInputNumber',
  data () {
    return {
      sum: 0,
      type: '',
      rawInput: ''
    }
  },
  props: {
    value: {
      type: Object,
      default: {value: 0, base: 2, valid: null}
    },
    binary: {
      type: Boolean,
      default: false
    },
    decimal: {
      type: Boolean,
      default: true
    },
    hexadecimal: {
      type: Boolean,
      default: false
    },
    signed_binary: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Enter an integer'
    }
  },
  mixins: [Numbers],
  computed: {
    valid: function () {
      return this.rawInput.length < 1 ? null : this.type !== ''
    },
    intValue: function () {
      if (this.decimal && NumberFormats.DECIMAL_RE.test(this.rawInput)) {
        this.type = 'decimal'
      } else if (this.hexadecimal && NumberFormats.HEXADECIMAL_RE.test(this.rawInput)) {
        this.type = 'hexadecimal'
      } else if (this.binary && NumberFormats.BINARY_RE.test(this.rawInput)) {
        this.type = 'binary'
      } else if (this.signed_binary && NumberFormats.BINARY_RE.test(this.rawInput)) {
        this.type = 'signed_binary'
      } else {
        this.type = ''
      }

      switch (this.type) {
        case 'decimal':
          this.decimalValue = this.rawInput
          return this.decimalInt
        case 'binary':
          this.binaryValue = this.rawInput
          return this.binaryInt
        case 'signed_binary':
          this.binaryValue = this.rawInput
          return this.signedBinaryInt
        case 'hexadecimal':
          this.hexadecimalValue = this.rawInput
          return this.hexadecimalInt
        default:
          return 0
      }
    }
  },
  methods: {
    returnValue: function () {
      return {value: this.intValue, base: bases[this.type], valid: this.binaryValid || this.decimalValid || this.hexadecimalValid}
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ucrdrk-input-number.vue